
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_gt2ai_97",
  "fit-height": "awsui_fit-height_14iqq_gt2ai_133",
  "with-side-media": "awsui_with-side-media_14iqq_gt2ai_138",
  "variant-default": "awsui_variant-default_14iqq_gt2ai_141",
  "variant-stacked": "awsui_variant-stacked_14iqq_gt2ai_141",
  "refresh": "awsui_refresh_14iqq_gt2ai_146",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_gt2ai_189",
  "with-top-media": "awsui_with-top-media_14iqq_gt2ai_201",
  "content-wrapper": "awsui_content-wrapper_14iqq_gt2ai_206",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_gt2ai_211",
  "media": "awsui_media_14iqq_gt2ai_216",
  "media-top": "awsui_media-top_14iqq_gt2ai_233",
  "media-side": "awsui_media-side_14iqq_gt2ai_238",
  "header": "awsui_header_14iqq_gt2ai_244",
  "header-with-media": "awsui_header-with-media_14iqq_gt2ai_249",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_gt2ai_255",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_gt2ai_259",
  "header-stuck": "awsui_header-stuck_14iqq_gt2ai_265",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_gt2ai_271",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_gt2ai_274",
  "with-paddings": "awsui_with-paddings_14iqq_gt2ai_280",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_gt2ai_286",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_gt2ai_333",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_14iqq_gt2ai_356",
  "dark-header": "awsui_dark-header_14iqq_gt2ai_365",
  "content": "awsui_content_14iqq_gt2ai_206",
  "content-fit-height": "awsui_content-fit-height_14iqq_gt2ai_373",
  "content-with-media": "awsui_content-with-media_14iqq_gt2ai_382",
  "footer": "awsui_footer_14iqq_gt2ai_386",
  "with-divider": "awsui_with-divider_14iqq_gt2ai_389"
};
  